/* istanbul ignore file */
import { minBreakpoints } from '@noths/polaris-client-ribbons-design-system';
import { mediaQuery, pxToRem, theme } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { spacing, fonts } = theme;

import {
  ICON_BUTTON__BUTTON_CLASS,
  ICON_BUTTON__ICON_CLASS,
} from 'src/components/atoms/IconButton';
import {
  ACCORDION__CONTENT_WRAPPER_CLASS,
  ACCORDION__HEADING_CLASS,
  ACCORDION__TITLE_CLASS,
} from './constants/classNames';

export const accordion = css`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  .${ICON_BUTTON__ICON_CLASS} {
    align-self: flex-start;
  }

  .${ACCORDION__HEADING_CLASS} {
    margin: 0;

    .${ICON_BUTTON__ICON_CLASS} {
      transform: rotate(180deg);
      transition: transform 0.5s;
      ${/* 
        This pushes it into the center of the first line of text. 
        I'm not sure if there is a better option and we will need something better
        if we do the responsive font sizing
      */ ''}
      margin-top: ${pxToRem(10)};

      ${mediaQuery(
        { min: minBreakpoints.L },
        css`
          margin-top: ${pxToRem(spacing.sm)};
        `,
      )};
    }
  }

  &[data-is-open='true'] {
    .${ICON_BUTTON__ICON_CLASS} {
      transform: rotate(0deg);
    }
  }

  .${ICON_BUTTON__BUTTON_CLASS} {
    display: flex;
    flex-direction: row-reverse;
    align-items: flex-start;
    background: none;
    border: none;
  }

  .${ACCORDION__TITLE_CLASS} {
    margin-right: ${pxToRem(spacing.sm)};
    font-family: ${fonts.PRIMARY_SEMIBOLD.family};
    font-weight: ${fonts.PRIMARY_SEMIBOLD.weight};
    text-transform: capitalize;
  }

  .js & {
    .${ACCORDION__CONTENT_WRAPPER_CLASS} {
      width: 100%;
      transition: height 0.5s;
      height: 0;
      overflow: hidden;
      > div {
        margin-top: ${pxToRem(spacing.xl)};
      }
    }
  }
`;
